import { TRIP_DETAILS_PAGE, getOptionalParamFromKey } from '#src/utils';
import { useRouter } from '@edreamsodigeo/frontend-core';

export const ON_FAILURE_REDIRECTION_PARAM_KEY = 'onFailureRedirectPath';

const getOnFailureRedirectPathFromUrlParam = (
  optionalParams
): string | undefined => {
  const paramValue = getOptionalParamFromKey(
    optionalParams,
    ON_FAILURE_REDIRECTION_PARAM_KEY
  );

  return paramValue;
};

export const useOnFailureRedirectPath = (): string => {
  const { query } = useRouter();

  const optionalParams = query?.params || [];
  const onFailureRedirectPath =
    getOnFailureRedirectPathFromUrlParam(optionalParams);

  return decodeURIComponent(onFailureRedirectPath ?? TRIP_DETAILS_PAGE);
};
